import React from "react";

import "./WizardPageTitle.scss";

export function WizardPageTitle({ children }) {
  return <div className="wizard-page-title">{children}</div>;
}
